(() => {
  const CSS_VAR = '--bottom-widgets-offset-y';

  const setOffset = (valuePx) => {
    document.documentElement.style.setProperty(CSS_VAR, `${valuePx}px`);
  };

  const computeOffset = () => {
    const body = document.body;
    if (!body) return 8;

    let offset = 8;

    const isMax1279 = window.matchMedia('(max-width: 1279px)').matches;
    const isMax959 = window.matchMedia('(max-width: 959px)').matches;

    const stickyBooking = body.querySelector('.sticky-booking');
    const stickyBookingHidden = !!stickyBooking?.classList.contains('hide');

    if (stickyBooking && !stickyBookingHidden) {
      offset = 56;
    }

    if (isMax959 && body.classList.contains('subnav-visible')) {
      offset = 60;
    }

    if (isMax1279 && body.querySelector('.sticky-categories-bar--outer-wrapper.visible')) {
      offset = 84;
    }

    if (
      !stickyBookingHidden &&
      body.querySelector('.sticky-booking .medispa-dropdown-trigger.open')
    ) {
      offset = 140;
    }

    return offset;
  };

  let rafId = null;
  const scheduleUpdate = () => {
    if (rafId) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      setOffset(computeOffset());
    });
  };

  const observe = () => {
    const body = document.body;
    if (!body) return;

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          scheduleUpdate();
          return;
        }
        if (m.type === 'childList') {
          scheduleUpdate();
          return;
        }
      }
    });

    observer.observe(body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    window.addEventListener('resize', scheduleUpdate, { passive: true });

    scheduleUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe, { once: true });
  } else {
    observe();
  }
})();
